// app/login/page.tsx  (PROYECTO B – puerto 3000)
'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

export default function LoginRedirectPage() {
  const AUTH_SERVER = process.env.NEXT_PUBLIC_AUTH_SERVER_URL!;
  const NEXTAUTH_URL = process.env.NEXT_PUBLIC_NEXTAUTH_URL;
  const searchParams = useSearchParams();

  useEffect(() => {
    const callbackBase =
      typeof window !== 'undefined'
        ? window.location.origin
        : NEXTAUTH_URL || 'http://localhost:3000';
    const defaultRedirect = new URL('/auth/callback', callbackBase).toString();
    const redirect = searchParams.get('redirect') || defaultRedirect;
    const state = searchParams.get('state') || 'prueba-local';

    const authUrl = `${AUTH_SERVER}/login?redirect=${encodeURIComponent(
      redirect
    )}&state=${encodeURIComponent(state)}`;

    window.location.href = authUrl;
  }, [searchParams]);

  return (
    <div style={{ padding: 20 }}>
      <h2>Redirigiendo al sistema de autenticación…</h2>
      <p>Por favor espera un momento.</p>
    </div>
  );
}
